export type { DeviceNameWithId } from './mapping';
export {
  makePatchDevicesInactive,
  mapDeviceCreateModelToFhir,
  mapDeviceToFhir,
  mapDeviceToNameAndId,
  mapFhirToDevice,
} from './mapping';
export type {
  CreateBulkDevicesRequest,
  CreateBulkDevicesResponse,
  CreateDeviceRequest,
  Device,
  DeviceCreateRequest,
  DeviceCreateResponse,
  DeviceGetAllParams,
  DeviceGetAllResponse,
  DeviceGetResponse,
  DeviceSearch,
  DeviceStatus,
  DeviceUpdateRequest,
  DeviceUpdateResponse,
  GetDevicesResponse,
  PatchCalibrateRequest,
  PatchCalibrateResponse,
  UpdateDeviceRequest,
} from './schema';
export {
  CreateBulkDevicesResponseSchema,
  CreateBulkDevicesSchema,
  CreateDeviceSchema,
  DeviceCodeSchema,
  DeviceGetAllResponseSchema,
  DeviceGetByIdSchema,
  DeviceSchema,
  DeviceSchemaMap,
  DeviceSearchSchema,
  DeviceStatusSchema,
  PatchCalibrateResponseSchema,
  PatchNameRegex,
  patchCalibrateRequestSchema,
  UpdateDeviceSchema,
} from './schema';
